module.exports = __webpack_public_path__ + "img/checkout_modal.9dd5cbc1.svg";